// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.


import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import {
  NavLink,
  HoverCard,
  PeekDeduction
} from '../'

import { showAsCurrency } from '../../utils'

export const PayslipDataRow = ({ id, payday, basicGross, totalGross, totalDeductions, nonPicsaDebtDeductions, payrollRunId, workflowrunDeductingId }) => (
  <tr key={`row_payslip_${id}`}>
    <td>
      {payrollRunId
        ? workflowrunDeductingId
          ? <HoverCard width={670} height={245} content={(ref, coords) => (
              <PeekDeduction ref={ref} coords={coords} deduction={workflowrunDeductingId}/>
            )}>
              <NavLink to={`/os/operations/general/payrollruns/${payrollRunId}`}>
                {moment(payday).format('lll')}
              </NavLink>
            </HoverCard>
          : <NavLink to={`/os/operations/general/payrollruns/${payrollRunId}`}>
              {moment(payday).format('lll')}
            </NavLink>
        : moment(payday).format('lll')
      }
    </td>
    <td>{showAsCurrency('R', basicGross)}</td>
    <td>{showAsCurrency('R', totalGross)}</td>
    <td>{showAsCurrency('R', totalDeductions)}</td>
    <td>{showAsCurrency('R', nonPicsaDebtDeductions)}</td>
  </tr>
)

PayslipDataRow.propTypes = {
  id: PropTypes.string.id,
  payday: PropTypes.string.isRequired,
  basicGross: PropTypes.number.isRequired,
  totalGross: PropTypes.number.isRequired,
  totalDeductions: PropTypes.number.isRequired,
  nonPicsaDebtDeductions: PropTypes.number.isRequired,
  payrollRunId: PropTypes.string,
  workflowrunDeductingId: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/payslips/PayslipDataRow.js